<template>
    <img src="@/assets/me.png">
</template>



<style scoped lang="scss">

</style>
